// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"4ba08fee29495498","src_app_modules_work-flow_work-flow_module_ts":"bdddc8c1ef4086f7","src_app_modules_workflow-debugger_workflow-debugger_module_ts":"3672d86ca6b348b1"}[chunkId] + ".js";
};